import { useTranslation } from 'react-i18next';

//necessary? component not used anywhere
export const NewMessageDivider = () => {
  const { t: tMessaging } = useTranslation('inAppMessaging');

  return (
    <div className="flex items-center">
      <p className="NewMessage-divider-text mb-[10px] mt-[10px] text-sm font-medium capitalize leading-[16px] text-palette-600 ">
        {tMessaging('conversation-new-message-divider')}
      </p>
      <div className="mb-[10px] mt-[10px] ml-[8px] h-[1px] w-full rounded-full bg-palette-600" />
    </div>
  );
};
